import * as React from "react";

import { ListeComponent } from "../Component/ListeComponent"
import { kolonne, hentData } from "../Component/components"
import { navigateToRoute } from "../Component/navigation"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;
import {appContext} from "../App/appContext";

export class FakturaPoliseTabell extends ListeComponent<Models.FakturaPoliseFeltType, Models.FakturaPoliseListeModell> {
    
    constructor(props: ILoaderProps) {
        super(props, 
            "FakturaPolise", 
            "Fakturagrunnlag", 
            (r, model) => navigateToRoute(`/Polise/${hentData(model, r, Models.FakturaPoliseFeltType.PoliseId)}`),
            false,
            1000);
    }

    getModelPathPage(page: number) { return `/${this.path}/Liste?q=fakturaId:${this.getId()}&offset=${((page + this.pageOffset) * this.pageSize)}&take=${this.pageSize}&order=${this.order || ""}` }

    getKolonner(model: Models.FakturaPoliseListeModell) {
        return [
            kolonne(model, Models.FakturaPoliseFeltType.SisteHendelseDato, "20%"),
            kolonne(model, Models.FakturaPoliseFeltType.PoliseNr, "20%"),
            kolonne(model, Models.FakturaPoliseFeltType.BruttoKr, "25%"),
            kolonne(model, Models.FakturaPoliseFeltType.ProvisjonKr, "20%"),
            kolonne(model, Models.FakturaPoliseFeltType.NettoKr, "20%")
        ];
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Faktura/FakturaPoliseTabell.tsx